import { Button as DevButton } from "devextreme-react/button";
import { useCallback, useEffect, useState } from "react";
import { bienLaiThuApi } from "../../../api/bienLaiApi";
import { showNotify } from "../../../helpers/toast";
import { sf_mucphaithu } from "../../../models/response/thu-phi/sf_mucphaithu";
import Button from "../../../components/ui/button";
import ModalActions from "../../../components/ui/modal/ModalActions";
import Modal from "../../../components/ui/modal";
import { PlaceHolder } from "../../place-holder";
import styles from "./TaoBienLai.module.css";
import { ChecklistIcon, XIcon } from "@primer/octicons-react";

type ThuPhiTaoBienLaiBtnProps = {
  disabled: boolean;
  sf_mucphaithu: sf_mucphaithu;
  usePopupButton?: boolean;
  printType?: "bienlai" | "thongbaophi";
  buttonText?: string;
};

const ThuPhiTaoBienLaiBtn = (props: ThuPhiTaoBienLaiBtnProps) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const isThongBaoPhi = props.printType === "thongbaophi";
  const printButtonText = props.buttonText || (isThongBaoPhi ? "In thông báo phí" : "In biên lai");

  const handleOpenModal = useCallback(() => {
    setIsShowModal(true);
  }, []);

  const handleCloseModal = useCallback(() => {
    setIsShowModal(false);
  }, []);

  return (
    <>
      {props.usePopupButton ? (
        <Button
          variant="default"
          text={printButtonText}
          iconClass="fa fa-print"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      ) : (
        <DevButton
          text={printButtonText}
          type="default"
          stylingMode="text"
          icon="print"
          className="p-btn-devextreme"
          disabled={props.disabled}
          onClick={handleOpenModal}
        />
      )}
      <Modal
        title={printButtonText}
        width="80%"
        isOpen={isShowModal}
        onClose={handleCloseModal}
      >
        <PrintModal
          sf_mucphaithu={props.sf_mucphaithu}
          printType={props.printType}
          onClose={handleCloseModal}
        />
      </Modal>
    </>
  );
};

type PrintModalProps = {
  sf_mucphaithu: sf_mucphaithu;
  printType?: "bienlai" | "thongbaophi";
  title?: string;
  onClose: () => void;
};

export const PrintModal = (props: PrintModalProps) => {
  const [print_url, set_print_url] = useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  useEffect(() => {
    handleFetchData();
  }, [props.sf_mucphaithu.id]);

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "p") {
        e.preventDefault();
        handlePrint();
      }
    };

    window.addEventListener("keydown", handleKeyDown);
    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [print_url]);

  const handleFetchData = async () => {
    setIsLoading(true);
    const isPhaithuGoc = props.sf_mucphaithu.so_chung_tu.includes("CT") || props.sf_mucphaithu.so_chung_tu.includes("RV");
    const data_send: any = {
      sf_mucphaithu_id: isPhaithuGoc
        ? props.sf_mucphaithu.id
        : props.sf_mucphaithu.sf_mucphaithu_parent_id,
      sf_mucphaithu_root_id: props.sf_mucphaithu.id,
    };
    const res = props.printType === "thongbaophi"
      ? await bienLaiThuApi.print_thongbaophi(data_send)
      : await bienLaiThuApi.print(data_send);
    if (res.is_success) {
      set_print_url(res.data);
    } else {
      set_print_url("");
      showNotify({ message: res.message || "Không tải được dữ liệu in", type: "warning" });
    }
    setIsLoading(false);
  };

  const handlePrint = () => {
    const iframe = document.getElementById("iframe_print_preview") as HTMLIFrameElement;
    if (iframe && iframe.contentWindow) {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
    } else {
      // Fallback for embed or if iframe is not available
      window.print();
    }
  };

  return (
    <div className={styles.custom_width}>
      <div style={{ padding: "0 10px" }}>
        {isLoading && <PlaceHolder line_number={20} />}
        {!isLoading && (
          <div id="embed_print_bienlai_container">
            {/* Sử dụng iframe cho cả 2 để đồng nhất cách in và preview */}
            <iframe
              id="iframe_print_preview"
              srcDoc={`
                  <html>
                    <head>
                      <style>
                        @media print {
                          * {
                            -webkit-print-color-adjust: exact !important;
                            print-color-adjust: exact !important;
                          }
                        }
                      </style>
                    </head>
                    <body>
                      ${print_url}
                      <script>
                        window.addEventListener("keydown", (e) => {
                          if ((e.ctrlKey || e.metaKey) && e.key === "p") {
                            e.preventDefault();
                            window.print();
                          }
                        });
                      </script>
                    </body>
                  </html>
                `}
              width="100%"
              height={window.innerHeight - 210}
              title={props.title || "Xem trước"}
              style={{ border: "1px solid #ddd", borderRadius: "4px" }}
            ></iframe>
          </div>
        )}
        <ModalActions>
          <Button
            variant="default"
            leadingVisual={XIcon}
            text="Đóng"
            onClick={props.onClose}
          />
          <Button
            variant="primary"
            leadingVisual={ChecklistIcon}
            text={props.printType === "thongbaophi" ? "In thông báo phí" : "In biên lai"}
            onClick={handlePrint}
            isLoading={isLoading}
            disabled={!print_url}
          />
        </ModalActions>
      </div>
    </div>
  );
};

export default ThuPhiTaoBienLaiBtn;
